import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { LocalizationProvider as MuiPickerProvider } from '@mui/x-date-pickers';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import theme from './core/theme';
import Router from './core/routing';

import { LocalizationProvider } from './core/contexts/localization';
import AppProvider from 'components/AppProvider';

import getDatepickerLocale from './core/locales/getDatepickerLocale';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

const App = () => {
    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
                <MuiPickerProvider dateAdapter={AdapterDateFns} adapterLocale={getDatepickerLocale()}>
                    <LocalizationProvider>
                        <AppProvider>
                            <Router />
                        </AppProvider>
                    </LocalizationProvider>
                    <ToastContainer />
                </MuiPickerProvider>
            </ThemeProvider>
        </StyledEngineProvider>
    );
};

App.displayName = 'App';

export default App;
